import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { useAppSelector } from 'modules/Editor/store';
import { selectInfographTitle } from 'modules/Editor/store/infographSelector';
import { Head } from 'modules/common/components/Head';

export const ResponsiveLinkHead = () => {
  const infographTitle = useAppSelector(selectInfographTitle);
  const { venngageE2 } = useVenngageE1Gate();
  const { firstName, lastName } = venngageE2?.designOwner || { firstName: '', lastName: '' };

  return <Head title={`${infographTitle} - by ${firstName} ${lastName}`} />;
};
